import { gql } from 'apollo-angular';

export const GET_PORTFOLIOS_LIST = gql`
  query ($tenantId: ID!) {
    portfolios(tenantId: $tenantId) {
      id
      tenantId
      alias
      name
      isDefault
    }
  }
`;

export const FIND_PORTFOLIO = gql`
  query ($id: ID!) {
    portfolio(id: $id) {
      id
      tenantId
      alias
      name
      isDefault
    }
  }
`;

export const CREATE_PORTFOLIO = gql`
  query ($tenantId: ID!) {
    portfolios(tenantId: $tenantId) {
      tenantId
      alias
      name
      isDefault
    }
  }
`;

export const DELETE_PORTFOLIO = gql`
  query ($id: ID!) {
    segment(id: $id) {
      id
    }
  }
`;

export const UPDATE_PORTFOLIO = gql`
  mutation ($id: ID!, $input: UpdatePortfolioInput!) {
    updatePortfolio(id: $id, input: $input) {
      id
      tenantId
      alias
      name
      isDefault
    }
  }
`;
